(() => {
  if (customElements.get('petomg-meta-dimensions')) return;

  class PetomgMetaDimensions extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.buttons = [...this.querySelectorAll('.pmd-units [data-unit]')];
      this.values = [...this.querySelectorAll('[data-in-text][data-cm-text]')];
      this.buttons.forEach((button) => button.addEventListener('click', () => {
        this.setUnit(button.dataset.unit);
      }, { signal: this.abort.signal }));
      this.setUnit(this.dataset.unit === 'cm' ? 'cm' : 'in');
    }

    setUnit(unit) {
      if (unit !== 'in' && unit !== 'cm') return;
      this.dataset.unit = unit;
      this.buttons.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.unit === unit));
      });
      this.values.forEach((value) => {
        value.textContent = unit === 'cm' ? value.dataset.cmText : value.dataset.inText;
      });
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
    }
  }

  customElements.define('petomg-meta-dimensions', PetomgMetaDimensions);
})();
